import React from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import Message from '../layout/Message';
import Button from '../layout/Button';
import FormField from '../layout/FormField';

import {
    fetchPianoTechCompanyList,
    RETURN_TO_PIANOTECHCOMPANY_LIST,
    SWITCH_EDIT_TYPE_PIANOTECHCOMPANY,
    PIANOTECHCOMPANY_MODIFIED,
    SAVE_PIANOTECHCOMPANY_STARTED,
    savePianoTechCompany,
    PIANOTECHCOMPANY_VALIDATE,
} from '../../actions/PianoTechCompanyActions';

import {
    MAINTENANCE_TYPE_VIEW,
    MAINTENANCE_TYPE_EDIT,
    MAINTENANCE_TYPE_ADD,
    MAINTENANCE_TYPE_COMPLETE,
    MAINTENANCE_TYPE_DELETE,
    uiFieldInfoPianoTechCompany,
    MESSAGE_TYPE_INFO,
    MESSAGE_TYPE_ERROR,
    defaultTravelTimes,
    defaultAppointmentTimes,
} from '../../app-constants';

import {
    validateForm,
    checkForChanges,
} from '../../utilities/validate';

const mapStateToProps = state => ({
    pianoTechCompany: state.pianoTechCompany,
    user: state.user,
});

class PianoTechCompany extends React.PureComponent {

    returnToList = () => {

        if (this.props.pianoTechCompany.maintenanceType === MAINTENANCE_TYPE_COMPLETE)
            this.props.dispatch(fetchPianoTechCompanyList());

        this.props.dispatch({
            type: RETURN_TO_PIANOTECHCOMPANY_LIST
        })
    }

    onCancelClose = () => {

        switch (this.props.pianoTechCompany.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
            case MAINTENANCE_TYPE_EDIT: {
                //Back to View Mode - restore original 
                const pianoTechCompany = Object.assign({}, this.props.pianoTechCompany.originalPianoTechCompany);
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE_PIANOTECHCOMPANY,
                    maintenanceType: MAINTENANCE_TYPE_VIEW,
                    title: "View PianoTechCompany",
                    pianoTechCompany,
                });

                break;
            }

            default:
                this.returnToList();
        }
    }

    editPianoTechCompany = () => {
        const pianoTechCompany = this.props.pianoTechCompany.pianoTechCompany;
        this.props.dispatch({
            type: SWITCH_EDIT_TYPE_PIANOTECHCOMPANY,
            maintenanceType: MAINTENANCE_TYPE_EDIT,
            title: "Edit PianoTechCompany",
            pianoTechCompany,
        });
    }

    onDelete = () => {
        switch (this.props.pianoTechCompany.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                this.saveAction();
                break;

            default:
                const pianoTechCompany = this.props.pianoTechCompany.pianoTechCompany;
                this.props.dispatch({
                    type: SWITCH_EDIT_TYPE_PIANOTECHCOMPANY,
                    maintenanceType: MAINTENANCE_TYPE_DELETE,
                    title: "Delete PianoTechCompany",
                    pianoTechCompany,
                });
        }
    }

    saveAction = () => {
        let message = '';

        switch (this.props.pianoTechCompany.maintenanceType) {
            case MAINTENANCE_TYPE_EDIT:
                message = 'Saving PianoTechCompany';
                break;
            case MAINTENANCE_TYPE_DELETE:
                message = 'Deleting PianoTechCompany';
                break;
            case MAINTENANCE_TYPE_ADD:
                message = 'Adding PianoTechCompany';
                break;

            default:

        }

        this.props.dispatch({
            type: SAVE_PIANOTECHCOMPANY_STARTED,
            message,
        })

        const { pianoTechCompany } = this.props.pianoTechCompany;
        pianoTechCompany.maintenanceType = this.props.pianoTechCompany.maintenanceType;
        this.props.dispatch(savePianoTechCompany(pianoTechCompany));
    }

    onChange = (e) => {
        const fieldName = e.target.name;
        let fieldValue = e.target.value;

        if (e.target.type === 'checkbox') {
            fieldValue = e.target.checked;
        }

        const { pianoTechCompany } = this.props.pianoTechCompany;
        pianoTechCompany[fieldName] = fieldValue;

        this.props.dispatch({
            type: PIANOTECHCOMPANY_MODIFIED,
            pianoTechCompany,
        })

    }

    formValid = () => {
        const { pianoTechCompany, maintenanceType } = this.props.pianoTechCompany;
        const validFormInfo = validateForm(uiFieldInfoPianoTechCompany, pianoTechCompany, maintenanceType);

        return validFormInfo.valid;
    }

    validate = () => {
        const { pianoTechCompany, maintenanceType } = this.props.pianoTechCompany;
        const validInfo = validateForm(uiFieldInfoPianoTechCompany, pianoTechCompany, maintenanceType);

        let message = '';
        let messageType = MESSAGE_TYPE_ERROR;

        if (validInfo.errors.length > 0) {
            validInfo.errors.map((err) => {
                message += err;
                return '';
            });
        } else {
            messageType = MESSAGE_TYPE_INFO;
            validInfo.info.map((info) => {
                message += info;
                return '';
            });
        }

        this.props.dispatch({
            type: PIANOTECHCOMPANY_VALIDATE,
            message,
            messageType,
        })
    }

    checkForChanges = () => {
        const { pianoTechCompany, originalPianoTechCompany, maintenanceType } = this.props.pianoTechCompany

        if (!this.formValid())
            return false;

        if (maintenanceType === 'add') {
            return true;
        }

        return checkForChanges(uiFieldInfoPianoTechCompany, pianoTechCompany, originalPianoTechCompany)

    }

    render() {
        const { pianoTechCompany } = this.props.pianoTechCompany;
        const { adminUser } = this.props.user;

        console.log('PianoTechCompany.jsx render pianoTechCompany: ' + JSON.stringify(pianoTechCompany));

        let showSave = false, showDelete = false, cancelCloseText = 'Cancel', showEdit = false,
            disabled = false, disableSave = false, deleteText = 'Delete';

        let showCompanyId = true;

        if (pianoTechCompany.companyId === '0') {
            showCompanyId = false;
        }

        console.log('this.props.pianoTechCompany.maintenanceType: ' + this.props.pianoTechCompany.maintenanceType);
        switch (this.props.pianoTechCompany.maintenanceType) {

            case MAINTENANCE_TYPE_DELETE:
                showDelete = true;
                disabled = true;
                deleteText = 'Confirm Delete';
                break;

            case MAINTENANCE_TYPE_COMPLETE:
                showSave = false;
                cancelCloseText = 'Close';
                disabled = true;
                break;

            case MAINTENANCE_TYPE_VIEW:
                showEdit = this.props.user.allowEdit;
                showDelete = this.props.user.allowDelete && adminUser;
                disabled = true;
                cancelCloseText = 'Close';
                break;

            default:
                if (this.props.user.allowEdit)
                    showSave = true;

                disableSave = !this.checkForChanges();
        }

        console.log('disableSave=' + disableSave + ' showSave=' + showSave + ' showDelete=' + showDelete + ' cancelCloseText=' + cancelCloseText);
        console.log('checkForChanges=' + this.checkForChanges() + ' formValid=' + this.formValid());
        return (
            <div className="divMedium" align="center">
                <Header header2={this.props.pianoTechCompany.title} />
                <Message message={this.props.pianoTechCompany.message}
                    type={this.props.pianoTechCompany.messageType} />
                <br />
                <table className='tableMedium'>
                    <tbody>
                        <tr>
                            {adminUser &&
                                <td>
                                    <Button className="bluebutton" description="Return to List" onClick={this.returnToList} />
                                </td>
                            }
                            <td>
                            </td>
                        </tr>
                        {showCompanyId &&
                            <FormField row form={{ title: 'Company Id', type: 'textinput', length: '10', maxLength: '10', disabled: true }}
                                name="companyId"
                                value={pianoTechCompany.companyId}
                                onChange={this.onChange}
                            />
                        }
                        <FormField row form={{ title: 'Company Name', type: 'textinput', length: '80', maxLength: '80', disabled }}
                            name="companyName"
                            value={pianoTechCompany.companyName}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'AddressLine1', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="addressLine1"
                            value={pianoTechCompany.addressLine1}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'AddressLine2', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="addressLine2"
                            value={pianoTechCompany.addressLine2}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'City', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="city"
                            value={pianoTechCompany.city}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'State', type: 'textinput', length: '20', maxLength: '20', disabled }}
                            name="state"
                            value={pianoTechCompany.state}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Country', type: 'textinput', length: '50', maxLength: '50', disabled }}
                            name="country"
                            value={pianoTechCompany.country}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Phone', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="encryptedPhone"
                            value={pianoTechCompany.encryptedPhone}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Tax Id', type: 'textinput', length: '100', maxLength: '100', disabled }}
                            name="encryptedTaxId"
                            value={pianoTechCompany.encryptedTaxId}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Default Minutes Per Appointment', type: 'select', options: defaultAppointmentTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled }}
                            name="defaultMinutesPerAppointment"
                            value={pianoTechCompany.defaultMinutesPerAppointment}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Default Travel Time Before (minutes)', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled }}
                            name="defaultBeforeAppointmentMinutes"
                            value={pianoTechCompany.defaultBeforeAppointmentMinutes}
                            onChange={this.onChange}
                        />
                        <FormField row form={{ title: 'Default Travel Time After (minutes)', type: 'select', options: defaultTravelTimes, optionTitle: 'description', optionValue: 'minutes', noEmptyOption: true, disabled }}
                            name="defaultAfterAppointmentMinutes"
                            value={pianoTechCompany.defaultAfterAppointmentMinutes}
                            onChange={this.onChange}
                        />
                        {showCompanyId &&
                            <React.Fragment>
                                <FormField row form={{ title: 'Created', type: 'textinput', length: '0', maxLength: '0', disabled }}
                                    name="created"
                                    value={pianoTechCompany.created}
                                    onChange={this.onChange}
                                />
                                <FormField row form={{ title: 'Last Updated', type: 'textinput', length: '0', maxLength: '0', disabled }}
                                    name="lastUpdated"
                                    value={pianoTechCompany.lastUpdated}
                                    onChange={this.onChange}
                                />
                            </React.Fragment>
                        }
                        <tr>
                            <td>
                                {showEdit &&
                                    <Button className="bluebutton" description="Edit" onClick={this.editPianoTechCompany} />
                                }
                                {showDelete &&
                                    <Button className="bluebutton2" description={deleteText} onClick={this.onDelete} />
                                }
                                {showSave &&
                                    <div>
                                        <Button className="bluebutton" description="Save" disabled={disableSave} onClick={this.saveAction} />
                                        <Button className="bluebutton2" description="Validate" onClick={this.validate} />
                                    </div>
                                }
                            </td>
                            {adminUser &&
                                <td>
                                    <Button className="bluebutton" description={cancelCloseText} onClick={this.onCancelClose} />
                                </td>
                            }
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }

}

export default connect(mapStateToProps)(PianoTechCompany);
